import React from 'react';
import Table from '@components/common/Table';
import { useTableSort } from '@components/common/Table/hooks';
import { track } from '@utils';
import { CLICK_SAVED_DASHBOARD_COLUMN_SORT } from '@src/utils/sensor/track';
import { Wrapper } from '../styled';

const defaultSort = { key: 'name', order: 'asc' };

const DashboardTable = ({ dashboards, columns }) => {
  const data = dashboards;
  const { sortBy, onColumnSort, sortedData } = useTableSort({ data, defaultSort });

  const onSort = (data) => {
    onColumnSort({ key: data.key, order: data.order });

    track({
      event: CLICK_SAVED_DASHBOARD_COLUMN_SORT,
      data: { key: data.key, order: data.order },
    });
  };

  return (
    <Wrapper>
      <Table
        data={sortedData}
        columns={columns}
        fixed={false}
        onColumnSort={onSort}
        sortBy={sortBy}
      />
    </Wrapper>
  );
};

export default DashboardTable;
